<template>
		<div class="grid grid-cols-1 lg:grid-cols-2 gap-4 relative">
				<!-- Background Image -->
				<div class="landing-image-width row-start-1 col-span-full">
						<img class="landing-background-image affordable-lawn-background-image w-full" :src="backgroundImage"
								alt="Landing Background" />
				</div>

				<!-- Content Section -->
				<div
						class="transleaf transleaf-affordable row-start-1 col-start-1 place-content-center px-8 col-end-1 md:col-end-3 flex flex-col items-center md:mt-1">
						<!-- Header Section -->
						<div class="flex flex-col md:flex-row items-center justify-center mt-5 space-y-4 md:space-y-0 md:space-x-4">
								<div class="p-3">
										<img loading="lazy" :src="logoImage" alt="Spring Green Established Logo" class="w-40 sm:w-60 md:w-80"  />
								</div>
								<div class="text-center md:text-left">
										<div class="text-2xl font-semibold leading-7">
												{{ mainHeading }}
										</div>
										<div class="pt-2 text-lg font-semibold">
												{{ subHeading }}
										</div>
								</div>
						</div>

						<!-- Description Section -->
						<div class="text-base mt-3 text-center md:text-left">
								{{ description }}
						</div>
				</div>
		</div>
</template>

<script setup lang="ts">
const props = defineProps({
		backgroundImage: {
				type: String,
				required: true,
		},
		logoImage: {
				type: String,
				required: true,
		},
		mainHeading: {
				type: String,
				required: true,
		},
		subHeading: {
				type: String,
				required: true,
		},
		description: {
				type: String,
				required: true,
		},
		currentPackage: {
			type: [Number, Object],
			default: null,
		},
});
</script>

<style scoped>
.landing-image-width img {
	width: 100%;
}

.landing-background-image {
	background-position: left -71px;
	/* Center the image */
	background-repeat: no-repeat;
	/* Do not repeat the image */
	background-size: 1440px 641px;
	/* Resize the background image to cover the entire container */
	height: 500px;
	border-bottom-left-radius: 70px;
}

.transleaf {
	max-height: 291px;
	max-width: 506px;
	background: linear-gradient(180deg,
			rgba(91, 179, 94, 0.309412) 0%,
			#5bb35e 100%);
	border-bottom-right-radius: 99px;
	border-top-left-radius: 99px;
	margin: 4em;
}

.transleaf h2 {
	font-style: normal;
	font-weight: 600;
	font-size: 36px;
	line-height: 40px;
}

.quote {
	background: #f7f7f7;
	border-radius: 36px;
	margin: 4em;
	padding: 1em 2em;
}

.quote h3 {
	font-style: normal;
	font-weight: 600;
	font-size: 26px;
	line-height: 32px;
	text-align: center;
	color: #517185;
	margin-top: 1rem;
}

.quote p {
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 22px;
	color: #517185;
}

.text h2 {
	font-family: Poppins;
	font-style: normal;
	font-weight: 600;
	font-size: 26px;
	line-height: 32px;
	color: #517185;
	font-display: swap;
}

.text h3 {
	font-style: normal;
	font-weight: 600;
	font-size: 18px;
	line-height: 22px;
	color: #517185;
}

.bg-gray-200 {
	background-color: #eef1f4;
}

h4 {
	font-family: Poppins;
	font-style: normal;
	font-weight: 600;
	font-size: 18px;
	line-height: 22px;
	text-align: center;
	color: #00810e;
	font-display: swap;
}

button {
	background: #00810e;
	border-radius: 100px;
	font-family: Poppins;
	font-style: normal;
	font-weight: bold;
	font-size: 18px;
	line-height: 22px;
	text-align: center;
	color: #ffffff;
	font-display: swap;
}

.reviews-inner {
	background: #fff;
	border-bottom-left-radius: 70px;
	padding: 0 0 40px;
}

@media (max-width: 1120px) {
	.transleaf {
		min-height: 220px;
		margin: 2em;
	}

	.quote {
		margin: 0.5em 1em;
	}
}

@media (max-width: 767px) {
	.transleaf h2 {
		font-size: 30px;
		line-height: 1.2;
		margin-top: 30px;
	}
}

.validation-error {
	color: #CE4200;
}

.checkbox {
	display: grid;
	grid-template-columns: min-content auto;
	grid-gap: 0.5em;
}

.checkbox__control {
	display: inline-grid;
	width: 1em;
	height: 1em;
	border-radius: 0.25em;
	border: 0.1em solid #00810e;
	background: #fff;
	color: white;
	margin-top: -3px;
}

.checkbox__control svg {
	transition: transform 0.1s ease-in 25ms;
	transform: scale(0);
	transform-origin: bottom left;
}

.checkbox__input {
	display: grid;
	grid-template-areas: "checkbox";
}

.checkbox__input input {
	opacity: 0;
	width: 0;
	height: 0;
}

.checkbox__input input:checked+.checkbox__control svg {
	transform: scale(1);
}

.checkbox__input input:checked+.checkbox__control {
	background: #00810e;
}


.transleaf-affordable {
	background: #fff;
	color: #517185;
	max-height: max-content;
	padding-bottom: 2rem;
	max-width: 750px;
	border-radius: 2rem;
	margin-right: 1.5rem;
}

.affordable-lawn-background-image {
	border-top-right-radius: 25px;
	border-bottom-right-radius: 25px;
	border-bottom-left-radius: 0px;
}
</style>